export default __webpack_public_path__ + "static/media/instagram.6d7e9d95.svg";